var _defs, _path, _g, _path2, _path3, _ellipse, _path4, _ellipse2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 142,
    viewBox: "0 0 281.67 301.95",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7562"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999",
    offset: 0.37223
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333",
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7580",
    x: -0.083318,
    y: -0.042725,
    width: 1.1666,
    height: 1.0855,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.31746016
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7717",
    x: -0.11291,
    y: -0.040855,
    width: 1.2258,
    height: 1.0817,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.61494821
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7607",
    x: -0.062366,
    y: -0.05098,
    width: 1.1247,
    height: 1.102,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4328259
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7633",
    x: -0.19921,
    y: -0.064927,
    width: 1.3984,
    height: 1.1299,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.22826063
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6909",
    x: -0.019994,
    y: -0.030012,
    width: 1.04,
    height: 1.06,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4940694
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient6913"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6c487",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffea",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6c487",
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6895",
    x: -0.025988,
    y: -0.0078011,
    width: 1.052,
    height: 1.0156,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.10929675
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6885",
    x: -0.028443,
    y: -0.0076041,
    width: 1.0569,
    height: 1.0152,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.20287065
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7624"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aa895c",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dbb77e",
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6867",
    x: -0.028003,
    y: -0.0076362,
    width: 1.056,
    height: 1.0153,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3153905
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7309",
    x: -0.10564,
    y: -0.03097,
    width: 1.2113,
    height: 1.0619,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2670265
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient6942"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7502",
    x: -0.3202,
    y: -0.10849,
    width: 1.6404,
    height: 1.217,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0158392
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6962",
    x: -0.097838,
    y: -0.022123,
    width: 1.1957,
    height: 1.0442,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9262768
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7841",
    x1: 1187,
    x2: 1177,
    y1: -211.26,
    y2: -187.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151515",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7843",
    x1: 753.76,
    x2: 843.29,
    y1: -223.27,
    y2: -229.15,
    gradientTransform: "matrix(1.0535 -.079525 .079525 1.0535 -707.64 617.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989783",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6f6f6c",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7845",
    x1: 772.09,
    x2: 785.82,
    y1: -185.14,
    y2: -188.9,
    gradientTransform: "matrix(1.0535 -.079525 .079525 1.0535 -707.64 617.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71736a",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4d4d4d",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7847",
    x1: 933.17,
    x2: 1007.2,
    y1: -216.64,
    y2: 125.79,
    gradientTransform: "translate(-479.72,235.66)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient6942"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7849",
    x1: 933.17,
    x2: 1007.2,
    y1: -216.64,
    y2: 125.79,
    gradientTransform: "translate(-100.43,-83.978)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient6942"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7851",
    x1: 783.69,
    x2: 832.39,
    y1: -142.58,
    y2: -82.474,
    gradientTransform: "matrix(1.0535 -.079525 .079525 1.0535 -707.64 617.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a0a193",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a0938d",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7853",
    x1: 959.86,
    x2: 798.38,
    y1: -95.763,
    y2: -55.412,
    gradientTransform: "matrix(1.0535 -.079525 .079525 1.0535 -707.64 617.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5a564a",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#784421",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient7855",
    cx: 782.41,
    cy: -110.3,
    r: 43.109,
    gradientTransform: "matrix(1.6156 .89574 -1.0362 1.8689 -1268 -62.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7857",
    x1: 1394.6,
    x2: 1283.9,
    y1: 402.33,
    y2: 320.86,
    gradientTransform: "matrix(1.0535 -.079525 .079525 1.0535 -1202.6 126.2)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient7624"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient7859",
    cx: 1225,
    cy: 365.52,
    r: 43.489,
    gradientTransform: "matrix(1.9982 .97636 -.65627 1.3431 -2091.4 -1278.5)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient7624"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient7861",
    cx: 1223.1,
    cy: 297.61,
    r: 29.603,
    gradientTransform: "matrix(2.0007 .73471 -.58182 1.5843 -2164.6 -1031.5)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient7624"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7863",
    x1: 1287.6,
    x2: 1310.8,
    y1: 332.57,
    y2: 418.92,
    gradientTransform: "translate(-727.01,-156.87)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient6913"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7865",
    x1: 1331.1,
    x2: 1263.7,
    y1: 317.69,
    y2: 262.82,
    gradientTransform: "matrix(1.0535 -.079525 .079525 1.0535 -1202.6 126.2)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient7624"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient7867",
    cx: 1224.3,
    cy: 254.83,
    r: 17.662,
    gradientTransform: "matrix(1.7195 .19294 -.1908 1.7004 -1949.2 -373.12)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient7624"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7869",
    x1: 1306.1,
    x2: 1258.1,
    y1: 267.67,
    y2: 235.39,
    gradientTransform: "matrix(1.0535 -.079525 .079525 1.0535 -1202.6 126.2)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient7624"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7871",
    x1: 1262.8,
    x2: 1280.9,
    y1: 288.51,
    y2: 288.51,
    gradientTransform: "translate(-727.01,-156.87)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient6913"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7873",
    x1: 816.5,
    x2: 827.12,
    y1: -254.11,
    y2: -254.11,
    gradientTransform: "translate(-294.83,342.18)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient6913"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7875",
    x1: 844.83,
    x2: 851.94,
    y1: -82.239,
    y2: -41.35,
    gradientTransform: "matrix(1.0535 -.079525 .079525 1.0535 -707.64 617.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9c9d9f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8a9d9f",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7877",
    x1: 844.83,
    x2: 851.94,
    y1: -82.239,
    y2: -41.35,
    gradientTransform: "matrix(1.0535 -.079525 .079525 1.0535 -707.64 617.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969799",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7881",
    x1: 1185.4,
    x2: 1183.9,
    y1: -183.13,
    y2: -218.05,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient7562"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7883",
    x1: 1185.4,
    x2: 1162.4,
    y1: -183.13,
    y2: -219.56,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient7562"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient7885",
    cx: 1022.6,
    cy: -203.41,
    r: 6.5354,
    gradientTransform: "matrix(1.5351,0,0,2.3522,-547.18,275.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7887",
    x1: 1010.2,
    x2: 1023.3,
    y1: -197.53,
    y2: -181.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5e6262",
    stopOpacity: 0.33166,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484a4a",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient7889",
    cx: 1027.7,
    cy: -135.16,
    r: 4.5424,
    gradientTransform: "matrix(1,0,0,1.7538,0,101.88)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7891",
    x1: 1023.4,
    x2: 1032,
    y1: -135.16,
    y2: -135.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient239",
    x1: 1187,
    x2: 1177,
    y1: -211.26,
    y2: -187.9,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient7841"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 297.01 -715.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.5061,492.77)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m116.18 467.58-0.81651 10.541 121.11-18.816 1.497-12.205z",
    fill: "#333"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0535 -.079525 .079525 1.0535 -866.98 557.03)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1056.1-66.906c-5.8476 0.35622-9.4965 0.47149-15.649 1.883-10.583 1.0614-16.736 19.635-14.696 40.976 2.04 21.342 12.261 37.786 22.844 36.725 7.9266-0.81106 9.1396-1.3425 15.055-1.8431 10.584-1.0614 17.508-19.239 15.468-40.581-2.0399-21.342-12.439-38.222-23.023-37.16z",
    fill: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.7809 -.1786 .17603 1.8416 -1023.4 562.71)",
    cx: 1180.4,
    cy: -204.98,
    rx: 10.76,
    ry: 20.983,
    fill: "url(#linearGradient239)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m83.97 315.79-2.7457 6.7996 83.776-7.7576-2.891-4.6641z",
    fill: "url(#linearGradient7843)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m21.733 230.3 17.707-3.9683c0.88275-0.19739 1.8198 0.34967 2.0976 1.2104l2.0111 6.2312c0.27781 0.86078-0.21042 1.7069-1.0947 1.8971l-20.297 4.3654c-0.88429 0.19019-2.0112-0.3101-2.0976-1.2105 0 0-1.0855-1.9028-1.1984-3.0003-0.11283-1.0974 0.59001-3.3368 0.59001-3.3368 0.17626-0.99681 1.3993-1.9904 2.2819-2.1882z",
    fill: "#9e0c0c"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.80517 -.060781 .079525 1.0535 -458.96 569.35)",
    cx: 652.06,
    cy: -284.1,
    rx: 6.8478,
    ry: 7.2283,
    fill: "#9e0c0c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m48.499 224.04c-4.8147 0.805-6.1197 1.769-6.1197 1.769s-1.4975 2.1729-0.53072 4.9468c0.9668 2.7739 2.5354 4.1234 2.5354 4.1234s2.9232-1.5999 5.5736-2.0431c1.3251-0.22155 2.3804-0.10924 2.856 0.11549 0.47561 0.22477 0.87139 0.37015 1.3188 2.1187 0.84021 3.2834 5.4476 19.078 12.132 41.86 6.6848 22.783 15.309 52.154 23.873 81.168 17.128 58.028 33.919 114.68 33.919 114.68l8.5495-2.5326s-16.759-56.656-33.886-114.68c-8.5634-29.012-17.222-58.358-23.904-81.133-6.6823-22.774-11.527-39.417-12.077-41.567-0.94275-3.6846-3.2839-6.6023-6.129-7.9469s-5.7043-1.28-8.1116-0.87756z",
    color: "#000000",
    fill: "url(#linearGradient7845)",
    style: {
      textIndent: 0,
      textTransform: "none"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0535 -.079525 .079525 1.0535 -424.25 233.63)",
    d: "m454.64 32.476c-1.3206 0.22367-0.028 4.9951 0.3885 4.0095l43.222 191.42 3.0625 13.531-0.875-4.1875-42.912-201.86s-1.5653-3.1353-2.8859-2.9116z",
    fill: "url(#linearGradient7847)",
    filter: "url(#filter6962)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.7536 -.30086 .3804 1.0472 -249.72 739.46)",
    cx: 652.06,
    cy: -284.1,
    rx: 6.8478,
    ry: 7.2283,
    fill: "#9e0c0c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m140.81 239.18c-0.65097 0.0417-1.3026 0.11009-1.9041 0.21409-4.8127 0.83147-7.4655 2.6252-7.4655 2.6252s-0.95461 2.4137 0.3811 5.4148c1.3356 3.001 3.0172 3.4202 3.0172 3.4202s2.9169-1.6815 5.5662-2.1392c1.3246-0.22885 2.3808-0.10535 2.8575 0.13475 0.47679 0.24008 0.87326 0.39578 1.3288 2.2494 0.52725 2.1458 2.8579 10.582 5.8911 21.439l9.0861-0.68673c-3.3843-12.102-6.0118-21.565-6.3772-23.051-0.95978-3.9059-3.3149-7.0058-6.1672-8.442-2.139-1.0772-4.261-1.3025-6.2141-1.1787z",
    color: "#000000",
    fill: "#71736a",
    style: {
      textIndent: 0,
      textTransform: "none"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0535 -.07962 .084329 1.1159 -706.3 634.07)",
    d: "m834.18-287.18c-0.084-0.0107-0.1675 0.0173-0.25 0.0312-1.3206 0.22367-0.042 4.9856 0.375 4l4.1563 18.438h2.5l-4.1563-19.531s-1.3649-2.7773-2.625-2.9375z",
    fill: "url(#linearGradient7849)",
    filter: "url(#filter7502)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m128.42 495.25 69.383-28.16-5.4708-90.702-74.181 10.437-13.354 25.998z",
    fill: "url(#linearGradient7851)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m175.52 476.79 104.58-26.705 20.415-8.9512-93.348 9.3267z",
    fill: "url(#linearGradient7853)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m128.42 495.25 69.383-28.16-5.4708-90.702-74.181 10.437-13.354 25.998z",
    fill: "none",
    stroke: "url(#radialGradient7855)",
    strokeWidth: 1.0565
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m176.6 357.25 36.277 103.33 87.498-19.194-32.661-85.317z",
    fill: "url(#linearGradient7857)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0535 -.079525 .079525 1.0535 -424.25 233.63)",
    d: "m515.96 281.92 10.222-2.6901-17.755-80.164 7.5322-2.1521-3.4971-12.912-9.1462-0.26901 2.4211 8.8773-8.3392 5.1111c2.7762 14.349 16.696 77.297 18.562 84.199z",
    fill: "#333",
    filter: "url(#filter7309)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m143.22 489.41 69.583-28.63-36.125-103.23-59.352 45.141z",
    fill: "url(#radialGradient7859)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m149.2 296.3 22.256 65.228-46.474 35.753-17.144-61.583z",
    fill: "url(#radialGradient7861)"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0535 -.079525 .079525 1.0535 -424.25 233.63)",
    d: "m559.09 160.57-0.9688 0.25 26.062 98.875 0.9687-0.25-26.062-98.875z",
    color: "#000000",
    fill: "url(#linearGradient7863)",
    filter: "url(#filter6867)",
    style: {
      textIndent: 0,
      textTransform: "none"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m149.14 295.5 72.216 6.2373 20.958 54.94-65.229 0.5637-6.3998 4.7498z",
    fill: "url(#linearGradient7865)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m115.37 328.73 28.363-27.534-12.057-34.107-25.389 29.227z",
    fill: "url(#radialGradient7867)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m143.9 301.72 5.5555-5.692 42.413 3.0685-9.7053-26.628-50.267-5.1831z",
    fill: "url(#linearGradient7869)"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0535 -.079525 .079525 1.0535 -424.25 233.63)",
    d: "m537.28 99.635-0.9687 0.25 16.418 63.78 0.6998-0.51901z",
    color: "#000000",
    fill: "url(#linearGradient7871)",
    filter: "url(#filter6885)",
    style: {
      textIndent: 0,
      textTransform: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0535 -.079525 .079525 1.0535 -424.25 233.63)",
    d: "m523.07 71.449-1.1393-0.18951 9.125 33.625 0.9687-0.95377z",
    color: "#000000",
    fill: "url(#linearGradient7873)",
    filter: "url(#filter6895)",
    style: {
      textIndent: 0,
      textTransform: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0535 -.079525 .079525 1.0535 -424.25 233.63)",
    d: "m558.58 159.53-59.305 38.531 0.1277 0.97825 58.969-38.127z",
    color: "#000000",
    fill: "#a6926f",
    filter: "url(#filter6909)",
    style: {
      textIndent: 0,
      textTransform: "none"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m127.46 495.55 45.28-19.541 26.829-7.6681 80.79-18.997-2.0416 4.9908-42.376 15.291z",
    fill: "url(#linearGradient7875)",
    stroke: "url(#linearGradient7877)",
    strokeWidth: 1.0565
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m109.99 246.21 17.707-3.9683c0.88274-0.19739 1.8198 0.34967 2.0976 1.2104l2.0111 6.2312c0.2778 0.86078-0.21043 1.7069-1.0947 1.897l-20.297 4.3654c-0.88427 0.19019-2.0112-0.31011-2.0976-1.2105 0 0-1.0855-1.9028-1.1984-3.0003-0.11293-1.0974 0.59001-3.3368 0.59001-3.3368 0.17625-0.99681 1.3993-1.9904 2.2819-2.1882z",
    fill: "#9e0c0c"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1571 -.16592 .16592 1.1571 -1064.2 888.46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1034.1-239.71c-5.2946-0.033-8.5919-0.15009-14.226 0.75-9.6078 0.31597-16.28 16.692-15.734 36.06 0.5467 19.368 8.7672 34.816 18.375 34.5 7.1968-0.25121 8.3228-0.65693 13.688-0.75 9.6078-0.31597 16.953-16.288 16.406-35.656-0.5467-19.368-8.9017-35.219-18.51-34.904z",
    fill: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.6167 -.053169 .047174 1.6713 -879.18 202.08)",
    cx: 1180.4,
    cy: -204.98,
    rx: 10.76,
    ry: 20.983,
    fill: "url(#linearGradient239)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.9998 -.019962 .019962 .9998 -157.2 25.261)",
    cx: 1180.4,
    cy: -204.98,
    rx: 10.76,
    ry: 20.983,
    fill: "none",
    filter: "url(#filter7580)",
    stroke: "url(#linearGradient7881)",
    strokeWidth: 2.0622
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.9998 -.019962 .019962 .9998 -157.74 26.468)",
    cx: 1180.4,
    cy: -204.98,
    rx: 10.76,
    ry: 20.983,
    fill: "#8a9090",
    stroke: "url(#linearGradient7883)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1022.1-221.47c-3.4767 1.8441-6.0938 9.134-6.0938 17.844 0 10.103 3.5041 18.281 7.8126 18.281 0.5053 0 0.9901-0.12853 1.4687-0.34375 2.422-3.8914 3.9147-9.8763 3.7813-16.562-0.174-8.7149-3.0263-16.127-6.9688-19.219z",
    fill: "url(#radialGradient7885)",
    filter: "url(#filter7717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1016.1-201.72-8.3125 0.40625c0.9079 10.246 5.5462 20.078 11 19.969 2.0964-0.0419 4.0426-1.2571 5.6562-3.3125 0 0-0.288-0.28001-0.75-0.71875-2.2781-0.12548-4.3233-2.5228-5.7187-6.2812-0.022-0.0434-0.041-0.0793-0.062-0.125-0.2863-0.61118-0.5025-1.4422-0.6875-2.3438-0.5905-2.2608-1.0026-4.8253-1.125-7.5938z",
    fill: "url(#linearGradient7887)",
    filter: "url(#filter7607)",
    opacity: 0.61873
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-4.1848,-68.478)",
    cx: 1027.7,
    cy: -135.16,
    rx: 3.9946,
    ry: 7.4185,
    fill: "url(#radialGradient7889)",
    filter: "url(#filter7633)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.56814 0 0 .56814 437.88 -126.64)",
    cx: 1027.7,
    cy: -135.16,
    rx: 3.9946,
    ry: 7.4185,
    fill: "url(#linearGradient7891)",
    filter: "url(#filter7633)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1022.6-207.66c-0.1566 0-0.321 0.0376-0.4687 0.0937 1.0223 0.40987 1.7812 2.1039 1.7812 4.125 0 2.0202-0.7597 3.7141-1.7812 4.125 0.1477 0.0561 0.3121 0.0937 0.4687 0.0937 1.2534 0 2.2813-1.891 2.2813-4.2188s-1.0279-4.2188-2.2813-4.2188z",
    fill: "#666",
    filter: "url(#filter7633)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandTruck);
export default __webpack_public_path__ + "static/media/hand-truck.a693aade.svg";
export { ForwardRef as ReactComponent };